export default __webpack_public_path__ + "static/media/customer_login.b1ddd462.svg";